import { COUNTRIES, COUNTRY_LABELS } from "@nh/shared";
import type { SelectOption } from "../core/Select/Select";
import { SelectField, type SelectFieldProps } from "./SelectField";

/**
 * La lista sale de `COUNTRIES` y `COUNTRY_LABELS` del contrato, no de un
 * arreglo escrito aquí: el día que se abra un tercer mercado, aparece en el
 * desplegable sin tocar el frontend, y nunca puede haber una opción que el
 * esquema del servidor rechace.
 */
const COUNTRY_OPTIONS: readonly SelectOption[] = COUNTRIES.map((country) => ({
  value: country,
  label: COUNTRY_LABELS[country],
}));

export interface CountryFieldProps extends Omit<SelectFieldProps, "name" | "options"> {
  /** Por defecto `"country"`, que es como se llama en los contratos. */
  name?: string;
}

/**
 * El país de una persona, con su configuración dentro.
 *
 * `autoComplete="country"` es el token que hace que el navegador ofrezca el
 * país guardado; sin él, el desplegable es el único campo del alta que
 * nadie puede autocompletar.
 */
export function CountryField({ name = "country", ...rest }: CountryFieldProps) {
  return (
    <SelectField
      label="País"
      placeholder="Elige tu país"
      autoComplete="country"
      options={COUNTRY_OPTIONS}
      {...rest}
      name={name}
    />
  );
}
